import {
  base_colorContentBorder,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_regular,
  font_md,
  font_sm,
  fontH2,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

/** Below this the six cells stop fitting side by side without truncating. */
const CELLS_BREAKPOINT = '1100px'

export const statsRow = css`
  display: grid;
  /* auto-fit + minmax rather than fixed columns: the row degrades to 3-up and
     then 2-up on its own, so there is no breakpoint list to keep in sync with
     the sidenav's collapsed/expanded widths. */
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: ${spacing(6)} ${spacing(4)};
  margin: 0;

  @media (max-width: ${CELLS_BREAKPOINT}) {
    gap: ${spacing(5)} ${spacing(4)};
  }
`

export const cell = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(1)};
  min-width: 0;
`

export const cellLabel = css`
  ${font_sm};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
  margin: 0;
`

export const cellValue = css`
  ${fontH2};
  color: ${text_colorTextPrimary};
  /* Keeps the six figures optically aligned as they change width. */
  font-variant-numeric: tabular-nums;
  margin: 0;
`

export const cellSub = css`
  ${font_sm};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
  margin: 0;
`

/** The utilization cell's bar sits in the sub slot, so it inherits its spacing. */
export const cellBar = css`
  margin-top: ${spacing(2)};
  max-width: ${spacing(55)};
`

/**
 * Surrogate-backed payment/statement data is really returned by the contract,
 * but is not a live issuer figure while the mock controllers serve it. Plain
 * text, not a colour or an icon, so the caveat survives for every user.
 */
export const provenance = css`
  ${font_sm};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
  display: block;
  margin-top: ${spacing(3)};
`

export const footer = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacing(1)} ${spacing(3)};
  margin-top: ${spacing(6)};
  padding-top: ${spacing(5)};
  border-top: 1px solid ${base_colorContentBorder};
`

export const footerText = css`
  ${font_md};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
`
